import React from 'react';
import i18n from '../../i18n';
import Button from "@material-ui/core/Button/Button";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Typography from "@material-ui/core/Typography/Typography";
import Grid from "@material-ui/core/Grid/Grid";
import CardActions from "@material-ui/core/CardActions/CardActions";
import {withStyles} from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip/Chip";
import {FormattedDate} from "react-intl";
import Icon from "@material-ui/core/Icon/Icon";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Divider from "@material-ui/core/Divider/Divider";
import EllipisWithTooltip from "../Formater/EllipsisWithTooltip";
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import DeleteButton from "../Form/DeleteButton";

class MachinesGrid extends React.Component {
    render() {
        const {machines, classes} = this.props;

        return (
            <Paper className={classes.paperProperties}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell> </TableCell>
                            <TableCell> </TableCell>
                            <TableCell> </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {machines.map(machine => (
                            <TableRow key={machine.id}>
                                <TableCell>
                                    {machine.name}
                                </TableCell>
                                <TableCell>
                                </TableCell>
                                <TableCell>
                                </TableCell>
                                <TableCell>
                                    {/*<DeleteButton*/}
                                    {/*    href={`/machines/${machine.id}`}*/}
                                    {/*    confirmMessage={i18n.get('qualifications.confirm_message')}*/}
                                    {/*    successMessage={i18n.get('qualifications.delete_success_message')}*/}
                                    {/*    handleSuccess={() => {history.go(-1)}}*/}
                                    {/*/>*/}
                                    <Tooltip placement="bottom-end" title={i18n.get('qualifications.edit')} classes={{tooltip : classes.popper}}>
                                        <IconButton href={`/machines/${machine.id}/edit`} className={classes.iconButton}>
                                            <Icon className={classes.iconButtonIcon}>edit</Icon>
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        )
    }
}

const styles = theme => ({
    paperProperties: {
        width: '650px',
        margin: 'auto',
    },
    cardContent: {
        minHeight: '150px'
    },
    cardActions: {
        padding: '4px 8px',
    },
    chip: {
        height: '24px',
    },
    chipLabel: {
        padding: '0 8px'
    },
    iconButton: {
        fontSize: 12,
        padding: '8px',
        opacity: 0.5,

        '&:hover': {
            color: theme.colors.primary,
            opacity: 1
        }
    },
    iconButtonIcon: {
        fontSize: 20
    },
    popper: {
        fontSize: 14,
        boxShadow: '2px 2px 3px rgba(0,0,0,0.3)'
    }
});

export default withStyles(styles)(MachinesGrid);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Machines/MachinesGrid.js